import api from '../../redux/api';
import { SELLER_V1_BASE } from './constants';

const base = `${SELLER_V1_BASE}/redemption-rules`;

export const sellerRedemptionRulesService = {
  getRedemptionRules: async () => {
    const response = await api.get(base);
    return response.data;
  },

  createRedemptionRule: async (ruleData) => {
    const { sellerId, ...data } = ruleData;
    const response = await api.post(base, data);
    return response.data;
  },

  updateRedemptionRule: async (ruleId, ruleData) => {
    const { sellerId, ...data } = ruleData;
    const response = await api.put(`${base}/${ruleId}`, data);
    return response.data;
  },

  closeRedemptionRule: async (ruleId) => {
    const response = await api.patch(`${base}/${ruleId}/close`);
    return response.data;
  },

  deleteRedemptionRule: async (ruleId) => {
    const response = await api.patch(`${base}/${ruleId}/delete`);
    return response.data;
  },

  // Task 5.4 — accepts optional { page, limit, source }. `source` is the QA
  // override for the audit-backed history; omitted means "let the server decide"
  // (REDEMPTION_HISTORY_SOURCE), which keeps the derived path as the default.
  getHistory: async (params = {}) => {
    const query = {};
    if (params.page) query.page = params.page;
    if (params.limit) query.limit = params.limit;
    if (params.source) query.source = params.source;
    const response = await api.get(`${base}/history`, { params: query });
    return response.data;
  },
};

export default sellerRedemptionRulesService;
